import Optimizely from '@optimizely/optimizely-sdk';
import { AsyncActionHandler } from 'action-handler';

export default new AsyncActionHandler({
  name: 'initialize_optimizely',
  stateProp: 'experiments',
  defaultState: {
    experiments: {
      galleryV2: false,
      gregEnabled: false
    }
  },
  handler() {
    return (_, getState) => {
      const {
        currentUser: { id },
        features: { flags }
      } = getState().registry;

      // the datafile might encounter a problem loading
      if (!window.optimizelyDatafile) {
        return this.defaultState;
      }

      Optimizely.setLogLevel(Optimizely.enums.LOG_LEVEL.ERROR);
      const optimizely = Optimizely.createInstance({
        datafile: window.optimizelyDatafile
      });

      let galleryV2 = true;
      if (flags.force_gallery_v1) {
        galleryV2 = false;
      } else if (flags.force_gallery_v2) {
        galleryV2 = true;
      } else {
        galleryV2 = optimizely.isFeatureEnabled('gallery_v2', id);
      }

      const gregVariation = optimizely.activate('gallery_recommendations', id);
      const gregEnabled = gregVariation === 'enabled';
      let userContext = optimizely.createUserContext(id);

      return {
        experiments: {
          galleryV2,
          gregEnabled,
          userContext
        }
      };
    };
  },
  reduce(_, { experiments }) {
    return {
      experiments
    };
  }
});
